import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { numberNanable } from "commons/ultilities/validation";
import { cloneDeep } from "lodash";
import {
  IAddWorkOrderPo,
  IUpdateWorkOrderPo,
  IUpdateWorkOrderPoStatus,
} from "mobx-stores/_models/work-order-po/work-order-po";

import { date, number, string } from "yup";

export const getAddWorkOrderPoFormSchema = (
  form: IForm,
): ObjectSchemaType<IAddWorkOrderPo> => {
  return {
    woPoLabelReadOnlyInfo: {
      type: InputType.label,
      gridSize: 12,
      label: "Thông Tin Đơn Hàng & Lệnh Sản Xuất",
      disabled: true,
    },
    dealingNameReadOnlyInfo: {
      type: InputType.text,
      gridSize: 6,
      label: "Tên giao dịch",
      disabled: true,
    },
    productCodeReadOnlyInfo: {
      type: InputType.text,
      gridSize: 6,
      label: "Mã hàng",
      disabled: true,
    },
    purchaseOrderItemId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Tên hàng",
      validattionYupSchema: string().required(),
    },
    productBarcodeReadOnlyInfo: {
      type: InputType.text,
      gridSize: 6,
      label: "Mã vạch",
      disabled: true,
    },
    orderDateReadOnlyInfo: {
      type: InputType.datePicker,
      gridSize: 6,
      label: "Ngày đặt hàng",
      disabled: true,
    },
    purchaseOrderId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Số đơn hàng",
      validattionYupSchema: string().required(),
      metaData: createDomainPagedAutoCompleteMetaData("order"),
    },
    date: {
      gridSize: 6,
      label: "Ngày Ra Lệnh",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },
    deliveryDateReadOnlyInfo: {
      type: InputType.datePicker,
      gridSize: 6,
      label: "Ngày giao hàng",
      disabled: true,
    },
    woNumber: {
      gridSize: 6,
      label: "Số Lệnh S/X",
      type: InputType.text,
      validattionYupSchema: string().required().max(50),
    },
    orderAmountReadOnlyInfo: {
      type: InputType.number,
      gridSize: 6,
      label: "Số lượng",
      disabled: true,
    },
    woBatchNumber: {
      gridSize: 6,
      label: "Số Lô S/X",
      type: InputType.text,
      validattionYupSchema: string().required().max(50),
    },
    orderAmountUpperReadOnlyInfo: {
      type: InputType.number,
      gridSize: 6,
      label: "S/L Trên",
      disabled: true,
    },
    productionAmount: {
      gridSize: 6,
      label: "Số Lượng Sản Xuất",
      type: InputType.number,
      validattionYupSchema: number()
        .min(1)
        .required(),
    },
    orderAmountLowerReadOnlyInfo: {
      type: InputType.number,
      gridSize: 6,
      label: "S/L Dưới",
      disabled: true,
    },
    orderNumber: {
      type: InputType.number,
      gridSize: 6,
      label: "STT",
      validattionYupSchema: numberNanable(),
    },
    note: {
      gridSize: 12,
      label: "Ghi chú",
      type: InputType.textArea,
      validattionYupSchema: string().max(512),
    },
    paperProductionInfoLabel: {
      type: InputType.label,
      gridSize: 12,
      label: "Công Đoạn Xuất Vật Tư Giấy",
    },
    poItemProductionAmount: {
      gridSize: 6,
      label: "S/L Sản Xuất",
      type: InputType.number,
      validattionYupSchema: number()
        .min(1)
        .required(),
    },
    totalPaperWeight: {
      gridSize: 6,
      label: "Trọng Lượng Giấy",
      type: InputType.number,
      validattionYupSchema: number().nullable(),
      disabled: true,
    },
    paperTypeReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Loại giấy",
      disabled: true,
    },
    gsmReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Định Lượng",
      disabled: true,
    },
    paperBrandReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Hiệu giấy",
      disabled: true,
    },
    firstFullPaperSizeReadOnlyInfo: {
      type: InputType.number,
      gridSize: 4,
      label: "Khổ Giấy 1",
      disabled: true,
    },
    firstFullPaperLengthReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Chiều Dài",
      disabled: true,
    },
    poItemFirstFullPaperAmount: {
      gridSize: 4,
      label: "S/L Tờ",
      type: InputType.number,
      validattionYupSchema: number().nullable(),
    },
    secondFullPaperSizeReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Khổ Giấy 2",
      disabled: true,
    },
    secondFullPaperLengthReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Chiều Dài",
      disabled: true,
    },
    poItemSecondFullPaperAmount: {
      gridSize: 4,
      label: "S/L Tờ",
      type: InputType.number,
      validattionYupSchema: number().nullable(),
    },
    firstPrintPaperSizeReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Khổ giấy in 1",
      disabled: true,
    },
    firstPrintPaperLengthReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Chiều dài",
      disabled: true,
    },
    poItemFirstPrintPaperAmount: {
      gridSize: 4,
      label: "S/L Tờ",
      type: InputType.number,
      validattionYupSchema: number().nullable(),
    },
    secondPrintPaperSizeReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Khổ giấy in 2",
      disabled: true,
    },
    secondPrintPaperLengthReadOnlyInfo: {
      type: InputType.text,
      gridSize: 4,
      label: "Chiều dài",
      disabled: true,
    },
    poItemSecondPrintPaperAmount: {
      gridSize: 4,
      label: "S/L Tờ",
      type: InputType.number,
      validattionYupSchema: number().nullable(),
    },
    poItemNote: {
      gridSize: 12,
      label: "Ghi chú",
      type: InputType.textArea,
      validattionYupSchema: string().max(512),
    },
  };
};

export const getEditWorkOrderPoFormSchema = (
  form: IForm,
): ObjectSchemaType<IUpdateWorkOrderPo> => {
  const schema = getAddWorkOrderPoFormSchema(form);
  const updateSchema: ObjectSchemaType<IUpdateWorkOrderPo> = cloneDeep(schema);
  updateSchema.id = {
    type: InputType.none,
  };

  return updateSchema;
};

export const getUpdateWorkOrderPoStatusSchema =
  (): ObjectSchemaType<IUpdateWorkOrderPoStatus> => ({
    statusId: {
      type: InputType.select,
      gridSize: 12,
      label: "Trạng thái lệnh sản xuất",
      validattionYupSchema: string().required(),
    },
    isCompensating: {
      type: InputType.checkbox,
      gridSize: 12,
      label: "Bù hàng",
    },
  });
